import React from "react";
import "./App.css";
import Redoc from "./components/Redoc";
import MarkdownRenderer from "./components/MarkdownRenderer";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <MarkdownRenderer
                path={
                  process.env.REACT_APP_ENV
                    ? `/README.${process.env.REACT_APP_ENV}.md`
                    : "/README.prod.md"
                }
              />
            }
          />
          <Route path="/documentation" element={<Redoc />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
